var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatepickerCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5 8.56303H2.5M13.3333 1.89636V5.2297M6.66667 1.89636V5.2297M6.5 18.563H13.5C14.9001 18.563 15.6002 18.563 16.135 18.2905C16.6054 18.0509 16.9878 17.6684 17.2275 17.198C17.5 16.6632 17.5 15.9632 17.5 14.563V7.56303C17.5 6.1629 17.5 5.46283 17.2275 4.92805C16.9878 4.45765 16.6054 4.0752 16.135 3.83551C15.6002 3.56303 14.9001 3.56303 13.5 3.56303H6.5C5.09987 3.56303 4.3998 3.56303 3.86502 3.83551C3.39462 4.0752 3.01217 4.45765 2.77248 4.92805C2.5 5.46283 2.5 6.1629 2.5 7.56303V14.563C2.5 15.9632 2.5 16.6632 2.77248 17.198C3.01217 17.6684 3.39462 18.0509 3.86502 18.2905C4.3998 18.563 5.09987 18.563 6.5 18.563Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepickerCalendar);
export default __webpack_public_path__ + "static/media/datepicker-calendar.613a2f120991be577022689dc8ce41ee.svg";
export { ForwardRef as ReactComponent };